import React, { useEffect, useState } from 'react';
import { obtenerHistorial } from '../../services/seguimientoExpedientesService';

// Mismo criterio que el resto de Seguimiento de Expedientes: OK se separa en "con/sin novedades"
// porque a partir de ahora solo se notifica in-app/mail cuando hay novedades reales — este
// historial es donde queda visible también lo que pasó "sin novedades" o en automático.
const ESTILO_RESULTADO = {
    CON_NOVEDADES: { texto: 'Con novedades', fg: '#0F6E56', bg: '#E1F5EE' },
    SIN_NOVEDADES: { texto: 'Sin novedades', fg: '#64748b', bg: '#f1f5f9' },
    ERROR: { texto: 'Falló', fg: '#991b1b', bg: '#fee2e2' },
    SESION_EXPIRADA: { texto: 'Sesión expirada', fg: '#92400e', bg: '#fef3c7' },
    CHALLENGE: { texto: 'Bloqueado por ANSES', fg: '#9a3412', bg: '#ffedd5' },
    INSTANCIA_MULTIPLE: { texto: 'Sesión abierta en otro lado', fg: '#9a3412', bg: '#ffedd5' },
};

const clasificarResultado = (log) => {
    if (log.estado === 'OK') return log.novedadesDetectadas > 0 ? 'CON_NOVEDADES' : 'SIN_NOVEDADES';
    return log.estado;
};

// iniciadoPor: el email de quien clickeó "Actualizar", 'login' si vino de un login (alta de
// cliente, VNC), o null si lo disparó el keep-alive/scheduler solo — ver sincronizacionService.js.
const etiquetaOrigen = (iniciadoPor) => {
    if (!iniciadoPor) return 'Automático';
    if (iniciadoPor === 'login') return 'Login';
    return iniciadoPor;
};

const ModalHistorialAnses = ({ open, cuil, onClose }) => {
    const [logs, setLogs] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!open) return;
        setCargando(true);
        setError(false);
        obtenerHistorial(cuil)
            .then(setLogs)
            .catch(() => setError(true))
            .finally(() => setCargando(false));
    }, [open, cuil]);

    if (!open) return null;

    return (
        <div
            style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 4000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
            onClick={onClose}
        >
            <div
                style={{ background: '#fff', borderRadius: 16, width: 760, maxWidth: '100%', maxHeight: '85vh', display: 'flex', flexDirection: 'column', boxShadow: 'var(--shadow-lg)', overflow: 'hidden' }}
                onClick={(e) => e.stopPropagation()}
            >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '20px 28px', background: 'var(--primary-text)', color: '#fff', flexShrink: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <i className="bi bi-clock-history" style={{ fontSize: '1.3rem' }} />
                        <div>
                            <h5 style={{ margin: 0, fontWeight: 700, fontSize: '1.05rem' }}>Historial de sincronización</h5>
                            <div style={{ fontSize: 12, opacity: 0.85 }}>CUIL {cuil}</div>
                        </div>
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 8, cursor: 'pointer', color: '#fff', width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
                    >
                        <i className="bi bi-x-lg" />
                    </button>
                </div>

                <div style={{ padding: '20px 28px', overflowY: 'auto' }}>
                    {cargando ? (
                        <div className="text-center py-4"><div className="spinner-border spinner-border-sm text-primary" /></div>
                    ) : error ? (
                        <div className="alert alert-danger py-2" style={{ fontSize: 13 }}>No se pudo cargar el historial. Probá de nuevo.</div>
                    ) : logs.length === 0 ? (
                        <p className="text-center text-muted py-4" style={{ fontSize: 13 }}>Todavía no hay sincronizaciones registradas para este cliente.</p>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-sm table-hover" style={{ fontSize: 13 }}>
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Hora</th>
                                        <th>Resultado</th>
                                        <th>Expedientes</th>
                                        <th>Origen</th>
                                        <th>Detalle</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {logs.map((log, i) => {
                                        const [fecha, hora] = (log.fechaHora || '—').split(' ');
                                        const estiloResultado = ESTILO_RESULTADO[clasificarResultado(log)] || ESTILO_RESULTADO.ERROR;
                                        return (
                                            // eslint-disable-next-line react/no-array-index-key
                                            <tr key={i}>
                                                <td style={{ whiteSpace: 'nowrap' }}>{fecha || '—'}</td>
                                                <td style={{ whiteSpace: 'nowrap' }}>{hora || '—'}</td>
                                                <td>
                                                    <span
                                                        className="badge"
                                                        style={{ background: estiloResultado.bg, color: estiloResultado.fg, padding: '0.4rem 0.7rem', borderRadius: 6, fontWeight: 600 }}
                                                    >
                                                        {estiloResultado.texto}
                                                    </span>
                                                </td>
                                                <td style={{ color: '#6B7280' }}>
                                                    {log.estado === 'OK'
                                                        ? `${log.expedientesRevisados ?? 0} revisado(s)${log.novedadesDetectadas ? `, ${log.novedadesDetectadas} con novedad` : ''}`
                                                        : '—'}
                                                </td>
                                                <td style={{ color: '#6B7280' }}>{etiquetaOrigen(log.iniciadoPor)}</td>
                                                <td style={{ color: '#993556', maxWidth: 260 }}>{log.mensajeError || ''}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ModalHistorialAnses;
